var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fieldComponent)?_c(_vm.fieldComponent,{tag:"component",class:{ 'alternate': _vm.index % 2 },attrs:{"field":_vm.field}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }